import 'boxicons/css/boxicons.min.css'
import './assets/tailwind.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VCalendar from 'v-calendar';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import * as Sentry from "@sentry/vue";

Vue.use(VueTelInput);
Vue.config.productionTip = false

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});
import "@fontsource/comfortaa/400.css"; // Specify weight

Sentry.init({
  Vue,
  dsn: "https://c84cbbd1310b5dfe1828bc7b01aa391b@o4509722830831616.ingest.de.sentry.io/4509722833911888",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    })
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [window.location.origin],
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
